module.exports = __webpack_public_path__ + "static/img/logo.ddfb430.png";


//////////////////
// WEBPACK FOOTER
// ./static/index/logo.png
// module id = Gm5z
// module chunks = 74